import Icon from "./icon-base";
import {
	rotateMarker,
	direction as directionMarker,
	problem as problemMarker,
	stopped as stoppedMarker
} from "@/data/map-markers";

export default {
	name: "KTrucksMapTruckIcon",

	mixins: [ Icon ],

	computed: {
		marker() {
			if ( this.truck.unreachable ) {
				return problemMarker;
			} else if ( this.truck.speed ) {
				return rotateMarker( directionMarker, this.truck.bearing );
			}

			return stoppedMarker;
		}
	}
};
